// extracted by mini-css-extract-plugin
module.exports = {"accent":"Accent_accent__w5UZp","accent-small":"Accent_accent-small__MaRgf"};